import { apiFetch } from "./client";

export type CalendarEntry = {
  id: number;
  buchungsreferenz: string;
  gastname: string;
  einheit_id: number | null;
  einheit_name: string | null;
  check_in: string;
  check_out: string;
  check_in_time: string | null;
  check_out_time: string | null;
  status: string;
};

export type Unit = {
  id: number;
  name: string;
};

export function fetchCalendar(von: string, bis: string): Promise<CalendarEntry[]> {
  return apiFetch<CalendarEntry[]>(`/api/calendar?von=${von}&bis=${bis}`);
}

export function fetchUnits(): Promise<Unit[]> {
  return apiFetch<Unit[]>("/api/units");
}
